module.exports = {
      id: "tv-usage",
      viewBox: "0 0 24.014 24",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#tv",
      toString: function () {
        return this.url;
      }
    }